<template>
    <admin-page description="Carga masiva de ejercicios desde un Excel">
        <kimsa-file-picker :value="file" accept=".xlsx,.xls,.csv" placeholder="Seleccionar archivo"
            @change="file = $event" />

        <v-btn color="primary" class="black--text upload-btn mt-5" depressed :loading="loading" :disabled="!file"
            @click="loadExcel">
            Cargar ejercicios
        </v-btn>

        <div v-if="info" class="upload-info">
            <v-progress-circular v-if="loading" indeterminate size="16" width="2" color="accent" class="mr-2" />
            {{ info }}
        </div>
    </admin-page>
</template>

<script>
import { db } from "@/utils/Firebase"
import KimsaFilePicker from "@/components/common/inputs/KimsaFilePicker.vue"
import AdminPage from "@/components/admin/AdminPage.vue"
import { adminRouteGuard } from "@/utils/Admin"

export default {
    name: "AdminUploadExcel",
    components: { KimsaFilePicker, AdminPage },
    beforeRouteEnter: adminRouteGuard,
    data() {
        return {
            collectionName: 'exercises',
            file: null,
            loading: false,
            info: '',
        }
    },
    methods: {
        sanitizeJson(string = '') {
            if (typeof (string) === 'string') {
                return string
                    .replace(/(“|”|‘|‘)/g, '"')
            }
            return string
        },
        async importRows(rows) {
            const vm = this
            let index = 1
            try {
                for (let row of rows) {
                    let id = row.id || row.ID || null;
                    for (let i in row) {
                        let regex = new RegExp(/(\[|\]|\{|\})/)
                        if (regex.test(row[i])) {
                            try {
                                row[i] = JSON.parse(this.sanitizeJson(row[i]));
                            } catch (e) {
                                console.warn(`Fila ${index}: no se pudo parsear la columna "${i}"`, row[i])
                            }
                        }
                    }

                    let newRow = {
                        categories: row.categories,
                        types: row.types,
                        name: row.name,
                        equipments: row.equipments && typeof (row.equipments) === 'string' ? [row.equipments] : row.equipments || [],
                        video: (row.url || row.thumb) ? {
                            id: row.videoId || null,
                            ready: true,
                            url: row.url || null,
                            thumb: row.thumb || null
                        } : null,
                        hide: row.hide === 1,
                        owner: 'app',
                    }

                    vm.info = `${index} de ${rows.length} - ${newRow.name}`
                    id ? await db.collection(vm.collectionName).doc(id + '').set(newRow) :
                        await db.collection(vm.collectionName).add(newRow)
                    index++
                }
                vm.info = '¡Ejercicios subidos!'
            } catch (e) {
                console.error('importRows error', e)
                vm.info = `Error en la fila ${index}: ${e.message}`
            } finally {
                vm.loading = false
            }
        },
        loadExcel() {
            const vm = this
            if (!vm.file) return vm.info = 'Selecciona un archivo primero'
            vm.loading = true
            const reader = new FileReader()
            reader.onload = async (e) => {
                try {
                    const excel = new Uint8Array(e.target.result)
                    const XLSX = (await import("xlsx")).default
                    const workbook = XLSX.read(excel, { type: 'array' })
                    const worksheet = workbook.Sheets['Hoja 1'] || workbook.Sheets[workbook.SheetNames[0]]
                    if (!worksheet) {
                        vm.info = 'No se encontró ninguna hoja en el archivo'
                        vm.loading = false
                        return
                    }
                    const data = XLSX.utils.sheet_to_json(worksheet)
                    await this.importRows(data)
                } catch (e) {
                    console.error('loadExcel error', e)
                    vm.info = `Error al leer el archivo: ${e.message}`
                    vm.loading = false
                }
            };
            reader.readAsArrayBuffer(vm.file)
        }
    },
}
</script>

<style scoped>
.upload-btn {
    height: 40px !important;
    min-width: 180px;
    border-radius: 8px;
}

.upload-info {
    display: flex;
    align-items: center;
    margin-top: 16px;
    font-size: 13px;
    color: var(--v-txtSecondary-base);
}

@media (max-width: 600px) {
    .upload-btn {
        width: 100%;
    }
}
</style>
